import { Toast } from "vant";
import REQUEST_DATA from "@/api/requestHandler";
const state = {
    reasonList: []
};
const mutations = {
    setStateItem(state, data) {
        state[data.key] = data.value;
    }
};

const actions = {
    // 检测用户是否有资格参与活动
    async requestCheckUserJoinSatisfaction({ state, commit }, data) {
        try {
            const res = await REQUEST_DATA('checkUserJoinSatisfactionUri', data);
            if (res.data.code == 200) {
                data.cb && data.cb(res.data.data.satisfaction_status)
            } else {
                Toast(res.data.message)
                return false;
            }
        } catch (e) {
            return false;
        }
    },
    // 获取满意度标签列表
    async requestSatisfactionLableList({ state, commit }, data) {
        try {
            const res = await REQUEST_DATA('satisfactionLableListUri', data);
            if (res.data.code == 200) {
                commit("setStateItem", {
                    key: "reasonList",
                    value: res.data.data
                });
            } else {
                Toast(res.data.message)
                return false;
            }
        } catch (e) {
            return false;
        }
    },
    // 提交意见反馈\下次再说接口
    async requestSubmitAndCancel({ state, commit }, data) {
        try {
            const res = await REQUEST_DATA('submitAndCancelUri', data);
            if (res.data.code == 200) {
                data.cb && data.cb()
            } else {
                Toast(res.data.message)
                return false;
            }
        } catch (e) {
            return false;
        }
    },
};

export default {
    state,
    actions,
    mutations,
    namespaced: true
};
